export default {
    provide() {
        return {
            grid: this
        };
    },
    created() {
        window.Grid = this;
    },
    render(h) {
        return <div class="grid-layout">
            {this.$slots.default}
        </div>;
    }
};